import type { PaletteOptions } from '@mui/material/styles';

import DuDHeader from '../common/img/headergruen.jpg';

export const dndPalette: PaletteOptions = {
  primary: {
    main: '#90AF1B',
  },
  secondary: {
    main: '#004494',
  },
  header: {
    background: `url(${DuDHeader})`,
    color: '#FFFFFF',
  },
  menu: {
    background: 'transparent',
    color: '#FFFFFF',
  },
};
